export enum AutomationValueType {
	TEXT_INPUT = 'TEXT_INPUT',
	DROPDOWN = 'DROPDOWN',
	DATE_INPUT = 'DATE_INPUT',
	MULTI_SELECT_DROPDOWN = 'MULTI_SELECT_DROPDOWN',
	CHILD_SELECTION_DROPDOWN = 'CHILD_SELECTION_DROPDOWN',
}
